import { useEffect } from "react";

import { LocalStorageKeys } from "@is/constants";
import { LocalStorageService } from "@is/services";

function useSavePageUrl() {
  useEffect(() => {
    const url = window.location.href;

    LocalStorageService.setItem(LocalStorageKeys.StartUrl, url);
  }, []);
}

export default useSavePageUrl;
